var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTensovigas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8b8b8b;}.cls-2{fill:#4d4c4c;}.cls-3{fill:#e2e2e2;}.cls-4{fill:#9f9f9f;}.cls-5{fill:#b8b8b7;}.cls-6{isolation:isolate;}.cls-7{fill:#717070;}.cls-8{clip-path:url(#clippath-1);}.cls-9{fill:#bcbbbb;}.cls-10{clip-path:url(#clippath);}.cls-11{fill:none;}.cls-12{fill:#919191;}.cls-13{fill:#9c9b9b;}.cls-14{mix-blend-mode:multiply;}.cls-15{fill:#e9e9ea;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 544.24,
    cy: 540.72,
    r: 432.68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 544.24,
    cy: 540.72,
    r: 432.68
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 544.24,
    cy: 540.72,
    r: 432.68
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "419.88 965.38 419.88 1002.97 484.87 1038.56 484.87 1001.17 419.88 965.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "484.87 1001.17 484.87 1038.56 549.87 1001.18 549.87 963.39 484.87 1001.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "435.71 774.29 435.71 979.59 484.87 1007.86 484.87 802.57 435.71 774.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "581.34 683.54 405.9 783.95 484.87 802.72 484.87 1007.86 534.03 979.59 534.03 774.45 581.34 704.19 581.34 683.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "115.74 586.81 115.85 792.31 164.91 820.38 164.91 615.08 115.74 586.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "164.91 615.24 164.91 820.38 214.07 792.1 214.07 586.96 284 483.11 85.94 596.47 164.91 615.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "581.34 659.52 395.16 766.08 395.16 790.1 581.34 683.54 581.34 659.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "581.34 606.75 348.31 740.13 395.16 766.17 581.34 659.62 581.34 606.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "581.34 251.72 37.56 562.95 83.86 589.25 581.34 303.9 581.34 251.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "581.34 308.16 75.15 598.86 348.86 754.68 348.86 739.77 581.34 606.72 581.34 308.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.56 576.91 395.16 780.03 395.16 790.1 37.56 586.98 37.56 576.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "348.86 739.77 348.86 763.8 395.16 790.1 395.16 766.07 348.86 739.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.56 562.95 37.56 586.98 83.86 613.28 83.86 589.25 37.56 562.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "435.71 956.67 419.88 965.38 484.87 1000.98 484.87 991.73 435.81 964.99 435.71 956.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "484.87 991.73 484.87 1000.98 549.87 963.6 534.03 955.6 534.03 963.16 484.87 991.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "99.91 792.69 99.91 830.48 164.91 865.82 164.91 828.23 99.91 792.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "164.91 828.23 164.91 865.82 229.9 828.44 229.9 790.65 164.91 828.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "115.84 783.87 99.91 792.69 164.91 828.23 164.91 818.99 115.85 792.31 115.84 783.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "164.91 818.99 164.91 828.23 229.9 790.85 214.07 782.85 214.07 790.41 164.91 818.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "581.34 303.88 83.88 589.17 83.82 601.42 581.34 315.3 581.34 303.88"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "484.87 1001.17 484.87 1038.56 549.87 1001.18 549.87 963.39 484.87 1001.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "435.71 774.29 435.71 979.59 484.87 1007.86 484.87 802.57 435.71 774.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "484.87 802.72 484.87 1007.86 534.03 979.59 534.03 774.45 603.97 670.59 405.9 783.95 484.87 802.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "111.56 590.98 111.56 796.28 160.73 824.56 160.73 619.26 111.56 590.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "663.05 645.2 663.05 850.5 712.21 878.77 712.21 673.48 663.05 645.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "712.21 673.63 712.21 878.77 761.38 850.5 761.38 645.35 832.43 539.83 631.98 654.56 712.21 673.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "889.68 512.52 889.68 717.82 938.84 746.09 938.84 540.8 889.68 512.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "938.84 540.95 938.84 746.09 988 717.82 988 512.68 1055.29 412.29 862.27 522.76 938.84 540.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1075.44 376.73 395.16 766.08 395.16 790.1 1075.44 400.76 1075.44 376.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1028.58 350.79 348.3 740.13 395.16 766.17 1075.44 376.83 1028.58 350.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "712.19 176.83 37.56 562.95 83.86 589.25 757.93 202.61 712.19 176.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "749.74 211.45 75.15 598.86 348.86 754.68 348.86 739.77 1013.34 359.5 749.74 211.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.56 576.91 395.16 780.03 395.16 790.1 37.56 586.98 37.56 576.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "348.86 739.77 348.86 763.8 395.16 790.1 395.16 766.07 348.86 739.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.56 562.95 37.56 586.98 83.86 613.28 83.86 589.25 37.56 562.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "435.71 956.67 419.88 965.38 484.87 1000.98 484.87 991.73 435.81 963.22 435.71 956.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "484.87 991.73 484.87 1000.98 549.87 963.6 534.03 955.6 534.03 963.16 484.87 991.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "647.22 848.61 647.22 886.4 712.21 923.78 712.21 886.39 647.22 848.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "712.21 886.39 712.21 923.78 777.21 886.4 777.21 848.61 712.21 886.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "663.05 841.89 647.22 848.81 712.21 886.19 712.21 876.95 663.15 848.43 663.05 841.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "712.21 876.95 712.21 886.19 777.21 848.81 761.38 840.81 761.38 848.37 712.21 876.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "873.85 714.93 873.85 752.72 938.84 790.1 938.84 752.71 873.85 714.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "938.84 752.71 938.84 790.1 1003.84 752.72 1003.84 714.93 938.84 752.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "889.68 708.21 873.85 715.13 938.84 752.52 938.84 743.27 889.78 714.75 889.68 708.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "938.84 743.27 938.84 752.52 1003.84 715.13 988 707.13 988 714.69 938.84 743.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "95.73 794.83 95.73 832.62 160.73 870 160.73 832.61 95.73 794.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.56 788.11 95.73 795.03 160.73 832.41 160.73 823.16 111.67 794.65 111.56 788.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "757.93 202.61 83.88 589.17 83.82 601.42 757.91 213.77 757.93 202.61"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "419.88 963.39 419.88 1001.18 484.87 1038.56 484.87 1001.17 419.88 963.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "484.87 1001.17 484.87 1038.56 549.87 1001.18 549.87 963.39 484.87 1001.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "435.71 774.29 435.71 979.59 484.87 1007.86 484.87 802.57 435.71 774.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "484.87 802.72 484.87 1007.86 534.03 979.59 534.03 774.45 603.97 670.59 405.9 783.95 484.87 802.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "111.56 590.98 111.56 796.28 160.73 824.56 160.73 619.26 111.56 590.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "663.05 645.2 663.05 850.5 712.21 878.77 712.21 673.48 663.05 645.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "712.21 673.63 712.21 878.77 761.38 850.5 761.38 645.35 832.43 539.83 631.98 654.56 712.21 673.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "889.68 512.52 889.68 717.82 938.84 746.09 938.84 540.8 889.68 512.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "938.84 540.95 938.84 746.09 988 717.82 988 512.68 1055.29 412.29 862.27 522.76 938.84 540.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1075.44 376.73 395.16 766.08 395.16 790.1 1075.44 400.76 1075.44 376.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1028.58 350.79 348.3 740.13 395.16 766.17 1075.44 376.83 1028.58 350.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "712.19 176.83 37.56 562.95 83.86 589.25 757.93 202.61 712.19 176.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "749.74 211.45 75.15 598.86 348.86 754.68 348.86 739.77 1013.34 359.5 749.74 211.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "491.93 501.21 242.93 643.73 271.61 659.98 520.4 517.28 491.93 501.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "834.79 300.99 585.79 443.5 614.47 459.76 863.26 317.06 834.79 300.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "37.56 576.91 395.16 780.03 395.16 790.1 37.56 586.98 37.56 576.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "348.86 739.77 348.86 763.8 395.16 790.1 395.16 766.07 348.86 739.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.56 562.95 37.56 586.98 83.86 613.28 83.86 589.25 37.56 562.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "435.71 956.67 419.88 965.18 484.87 1000.98 484.87 991.73 435.81 963.22 435.71 956.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "484.87 991.73 484.87 1000.98 549.87 963.6 534.03 955.6 534.03 963.16 484.87 991.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "647.22 848.61 647.22 886.4 712.21 923.78 712.21 886.39 647.22 848.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "712.21 886.39 712.21 923.78 777.21 886.4 777.21 848.61 712.21 886.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "663.05 841.89 647.22 848.81 712.21 886.19 712.21 876.95 663.15 848.43 663.05 841.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "712.21 876.95 712.21 886.19 777.21 848.81 761.38 840.81 761.38 848.37 712.21 876.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "873.85 714.93 873.85 752.72 938.84 790.1 938.84 752.71 873.85 714.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "938.84 752.71 938.84 790.1 1003.84 752.72 1003.84 714.93 938.84 752.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "889.68 708.21 873.85 715.13 938.84 752.52 938.84 743.27 889.78 714.75 889.68 708.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "938.84 743.27 938.84 752.52 1003.84 715.13 988 707.13 988 714.69 938.84 743.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "95.73 794.83 95.73 832.62 160.73 870 160.73 832.61 95.73 794.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.56 788.11 95.73 795.03 160.73 832.41 160.73 823.16 111.67 794.65 111.56 788.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "757.93 202.61 83.88 589.17 83.82 601.42 757.91 213.77 757.93 202.61"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 0,
    width: 1080,
    height: 1080
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensovigas);
export default __webpack_public_path__ + "static/media/tensovigas.d006518bb97ccd1b6cc83c05ae8d8136.svg";
export { ForwardRef as ReactComponent };